<template>
  <div v-redirect-if-no-permission:SEASONAL_RESERVATION_CAPTAIN>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/seasonal_reservations/store"
      >{{ $t("maps.seasonalReservations.newSeasonalReservationTime") }}</v-btn
    >
    <DataTable
      ref="reserDataTable"
      :url="api.ACTIONS.SEASONAL_RESERVATIONS"
      :titles="titles"
      :fields-hidden-main="['id','created_at', 'updated_at','deleted_at']"
      :title="$t('maps.seasonalReservations.seasonalReservationAllowance')"
      :enableEdit="false"
      :enableAdd="false"
      :enableDelete="false"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";

export default {
  name: "Seasonal Reservation Allowance",
  title() {
    return this.$t("maps.seasonalReservations.title");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    titles() {
      return {
        id: this.$t("maps.seasonalReservations.id"),
        day: this.$t("maps.seasonalReservations.day"),
        start_time: this.$t("maps.seasonalReservations.startTime"),
        end_time: this.$t("maps.seasonalReservations.endTime"),
      };
    },
    actionsExtraMain() {
      return {
        editTime: {
          title: this.$t("maps.seasonalReservations.deleteSeasonalReservationTime"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "edit_seasonal_drivers_reservations_allowance",
              params: { id: item.id },
            }),
        },
        deleteTime: {
          title: this.$t("maps.seasonalReservations.deleteSeasonalReservationTime"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`seasonal_reservation/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("maps.seasonalReservations.deletedSuccessfully"),
                  "green"
                );
                this.$refs.reserDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("maps.seasonalReservations.somethingWentWrong"),
                    "red"
                  );
                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
